import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 'max-content',
    padding: '3rem 7rem',
    backgroundColor: theme.whiteColor,
  },
  title: {
    color: theme.darkSlateGrayColor,
    textTransform: 'uppercase',
  },
  link: {
    position: 'absolute',
    right: '7rem',
    top: '3rem',
    textTransform: 'uppercase',
    color: theme.lightCoralColor,
  },
  previewContainer: {
    display: 'grid',
    gridGap: '2rem',
    gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
    justifyItems: 'center',
    overflowY: 'hidden',
    height: '26rem',
    width: 'max-content',
    maxWidth: '100%',
    marginTop: '3rem',
  },
  noItemsFound: {
    marginTop: '2rem',
    color: theme.lightPinkColor,
  },
}));

export default useStyles;
